import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  SvgIcon,
} from '@mui/material';
import { Menu as MenuIcon } from 'react-feather';
import Logo from '../../Layout/Logo';
import Account from './Account';

import useStyles from './styles';
import { TopBarProps } from '../../../types';

function TopBar({
  className,
  ...rest
}: TopBarProps) {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        {/* <Hidden lgUp>
          <IconButton
            color="inherit"
            size="large">
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden> */}
        {/* <Hidden lgDown> */}
          <RouterLink to="/dashboard">
              <Logo width='71px' height='46px' />
          </RouterLink>
        {/* </Hidden> */}
        <Box
          ml={2}
          flexGrow={1}
        />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
};

export default TopBar;
